import React, { Fragment } from 'react'
import axios from 'axios'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../../../redux/AppDucks'
import { actualizarFileOCFC_09 } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC09_OCDuck';
function BotonSustituirComponent(props) {


    const dispatch = useDispatch()
    const [openModalSustituir, setOpenModalSustituir] = React.useState(true);

    const styleSustituir = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: 'fit-content',
        bgcolor: 'background.paper',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black',
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const handleOpenModalSustituir = () => {
        setOpenModalSustituir(true)
    }
    const handleCloseModalSustituir = async () => {
        setOpenModalSustituir(false)
        props.setOpenModalSustituir(false)
    }
    const handdleFile = async (objectFile) => {
        await dispatch(actualizarLoadingApp_true())
        let JSONFile = []
        let data = []
        if (props?.data?.tabla == 'fc_09archivos') {
            JSONFile = { id: props?.data?.idSolicitud, idAnexo: props?.data?.idSolicitud, file: objectFile, idAnexoFK: props.data?.idArchivo }
            data = { archivo: JSONFile, ruta: 'SolicitudFC09_OC/actualizarArchivoFC09General' }
        }
        if (props?.data?.tabla == 'fc_09archivoproducto') {
            JSONFile = { id: props?.data?.idSolicitud, idAnexo: props?.data?.idSolicitud, file: objectFile, idAnexoFK: props.data?.idArchivo }
            data = { archivo: JSONFile, ruta: 'SolicitudFC09_OC/actualizarArchivoFC09Producto' }
        }
        if (props?.data?.tabla == 'ocsolicitudfc01_fc11_documento') {
            JSONFile = { id: props?.data?.idSolicitud, idAnexo: props?.data?.idSolicitud, file: objectFile, idAnexoFK: props.data?.idArchivo }
            data = { archivo: JSONFile, ruta: 'SolicitudFC01_OC/actualizarArchivoFC_11' }
        }

        let result = await dispatch(actualizarFileOCFC_09(data))

        await dispatch(actualizarLoadingApp_false())
    }

    return (
        <Fragment>
            <Modal
                open={openModalSustituir}
                onClose={handleCloseModalSustituir}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleSustituir}>
                    <Typography id="modal-modal-title" variant="h5" sx={{ mt: 0, fontFamily: 'Montserrat', textAlign: 'center', fontWeight: 'bold' }}>
                        Sustituir archivo
                    </Typography>
                    <Typography id="modal-modal-description" component="h5" sx={{ mt: 3, fontFamily: 'Montserrat' }} className='text-center'>
                        <input className={`form-control `} type="file" accept="application/pdf" onChange={e => handdleFile(e.target.files[0])}></input>
                    </Typography>
                    <ThemeProvider theme={theme}>
                        <div className='row mt-3'>
                            <div className='text-center'>
                                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { handleCloseModalSustituir() }}>Cerrar</Button>
                            </div>
                        </div>
                    </ThemeProvider>
                </Box>
            </Modal>
        </Fragment>
    )
}

export default BotonSustituirComponent